import { useEffect, useState } from "react";

import { ITableLookup } from "../../../../base/models";
import { Spinner } from "../../../../widgets";
import { useGetLookupLabel } from "./useGetLookupLabel";

export const LookupDisplayName = ({ tableLookup, value, className }: {
    tableLookup: ITableLookup,
    value?: string,
    className?: string
}) => {
    const { getLookupLabel, isLoading } = useGetLookupLabel()
    const [name, setName] = useState<string>()

    useEffect(() => {
        getLookupLabel({ tableLookup, value })
            .then(name => setName(name))
        // eslint-disable-next-line
    }, [tableLookup, value])

    return (
        <label className={className}>
            <Spinner show={isLoading} />
            {name}
        </label>
    )
}
